export class WidgetPollingRate {
  pollingRate: string = '';
  pollingRateInS: number = -1;

  constructor(pollingRate: string, pollingRateInS: number) {
    this.pollingRate = pollingRate;
    this.pollingRateInS = pollingRateInS;
  }
}